// extracted by mini-css-extract-plugin
export default {"container":"Empty_container__a4vVe","content":"Empty_content__Fm3Sp","img":"Empty_img__HSUim"};